import {Mapper} from '@s-ui/domain'

export default class RelatedAdsRequestValueObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Config} config
   ** @param {Function} relatedAdsRequestValueObjectFactory
   */
  constructor({config, relatedAdsRequestValueObjectFactory}) {
    super()
    this._config = config
    this._relatedAdsRequestValueObjectFactory = relatedAdsRequestValueObjectFactory

    this._defaultCount = this._config.get('search').DEFAULT_RELATED_ADS_COUNT
    this._relatedAdContext = this._config.get('search').RELATED_AD_CONTEXT
  }

  _fromContextToPreferredContractModes(context) {
    switch (context) {
      case this._relatedAdContext.PRIVATE_DETAIL:
        return [21]
      case this._relatedAdContext.PROFESSIONAL_DETAIL_TYPE_DISCOVERY:
      case this._relatedAdContext.PROFESSIONAL_DETAIL_TYPE_START:
        return [21, 20]
      default:
        return []
    }
  }

  map = ({adId, count, context, offerTypeId} = {}) => {
    return this._relatedAdsRequestValueObjectFactory({
      adId,
      count: count || this._defaultCount,
      preferredContractModes: this._fromContextToPreferredContractModes(context),
      offerTypeId
    })
  }
}
